<template>
	<div>
		<div class="p-d-flex p-jc-center">
			<h2 class="titleFont p-text-bold">Step 4: Verify and Pay</h2>
		</div>

		<Transition name="fade" mode="out-in">
			<div v-if="!proceedBtnLoading" key="summary">
				<div class="p-d-flex p-flex-column column-line-spacing">
					<h1 class="p-mt-0 p-mb-2 p-primary-color">
						${{
							store.S1FormData.totalAmountAllLocations != undefined
								? store.S1FormData.totalAmountAllLocations.toFixed(2)
								: 0
						}}
						CAD
					</h1>
				</div>
				<div
					class="p-d-flex p-flex-column p-flex-md-row p-ai-sm-center p-ai-md-start p-jc-evenly column-line-spacing"
				>
					<div class="p-d-flex p-flex-column">
						<h4 class="p-mb-2" style="text-decoration: underline">
							Cookies Order Summary
						</h4>

						<div
							v-for="location in store.S1LocationsInfoData"
							:key="location.firstName"
							class="orderSummary p-mb-4"
						>
							<p class="p-text-bold" v-if="location.companyName">
								{{ location.companyName }}
							</p>
							<p class="p-text-bold p-mt-1">
								{{ location.firstName }}
								{{ location.lastName }} -
								<span> {{ location.cookiesQuantityDozens }} dozen cookies</span>
							</p>
							<p>{{ location.address }}</p>
							<p>{{ location.city }}</p>
							<p class="p-text-uppercase">{{ location.postalCode }}</p>
							<p>{{ location.phoneNumber }}</p>
							<p>{{ location.email }}</p>
						</div>
					</div>

					<div>
						<h4 class="p-mb-2" style="text-decoration: underline">
							Payment Information
						</h4>
						<div
							v-if="store.S3FormData.paymentMethodSB === 'CARD'"
							class="p-d-flex p-flex-column"
						>
							<span>Card Number: {{ maskedCardNumber() }}</span>

							<span>
								Expiry Date:
								{{ store.S3FormData.expiryMonth }}
								/{{ store.S3FormData.expiryYear }}
							</span>

							<span>Cardholder Name: {{ store.S3FormData.cardHolder }}</span>
						</div>
						<div v-else-if="store.S3FormData.paymentMethodSB === 'CCHQ'">
							<div>
								<p>Cheques are payable to:</p>
								<p class="p-text-bold">Regina Food Bank</p>
								<p>Memo:</p>
								<p class="p-text-bold">Smile Cookies</p>
							</div>
						</div>
					</div>
				</div>

				<div class="p-grid p-formgrid p-mt-3 p-jc-center">
					<div class="p-col-12 p-sm-8 p-md-6 p-lg-6 p-xl-5 p-ai-center">
						<div
							class="p-d-flex p-flex-column-reverse p-flex-sm-row p-ai-center p-jc-evenly"
						>
							<div class="p-mb-3">
								<Button
									label="Back"
									icon="pi pi-angle-left"
									class="p-button-secondary"
									style="min-width: 120px; max-width: 120px"
									:disabled="proceedBtnLoading ? 'disabled' : null"
									@click="prevStep"
								/>
							</div>

							<div class="p-mb-3">
								<Button
									label="Proceed to Pay"
									icon="pi pi-check"
									iconPos="right"
									style="min-width: 180px; max-width: 180px"
									:loading="proceedBtnLoading"
									@click="nextStep"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-else key="processing">
				<i
					class="pi pi-spin pi-spinner p-primary-color"
					style="font-size: 5rem"
				></i>
				<h2 class="titleFont p-text-center p-pt-2 p-text-bold">
					Processing your payment...
				</h2>
			</div>
		</Transition>
	</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

import { useFormDataStore } from "../../store/formData.js";

export default {
	name: "S4Form",
	data() {
		return {
			proceedBtnLoading: false,
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			store,
		};
	},
	methods: {
		async submitForm() {
			let token = await this.generateRecaptchaToken();

			let locationsData = [];
			Object.values(this.store.S1LocationsInfoData).forEach((location) => {
				locationsData.push({
					deliveryAddressType: location.deliveryAddressTypeRB,
					companyName: location.companyName,
					firstName: location.firstName,
					lastName: location.lastName,
					address: location.address,
					address2: location.address2,
					postalCode: location.postalCode,
					city: location.city,
					region: location.region,
					phoneNumber: location.phoneNumber,
					email: location.email,
					cookiesQuantityDozens: location.cookiesQuantityDozens,
					locationTotalAmount: location.locationTotalAmount,
				});
			});
			// console.log("locationsData", locationsData, locationsData.postalCode);
			// console.log({
			// 	...this.store.S1FormData,
			// 	...this.store.S2FormData,
			// 	...this.store.S3FormData,
			// 	queryString: window.location.search,
			// 	dt: moment(new Date(Date.now())).format(),
			// 	sandbox: this.store.testMode,
			// 	campaignId: this.store.campaignId,
			// 	token: token,
			// 	amount: this.store.S1FormData.totalAmountAllLocations,
			// 	locationsData,
			// });

			await axios
				.post(process.env.VUE_APP_PROCESS_API, {
					...this.store.S1FormData,
					...this.store.S2FormData,
					...this.store.S3FormData,
					queryString: window.location.search,
					dt: moment(new Date(Date.now())).format(),
					token: token,
					amount: this.store.S1FormData.totalAmountAllLocations,
					sandbox: false,
					// window.location.hostname ==
					// "https://rfb-smile-cookie-forms.staging.pllenty.com" ||
					// window.location.hostname ==
					// "https://d1ujdsiwtz9qs3.cloudfront.net" ||
					// window.location.hostname == "localhost"
					// ? true
					// : this.store.testMode,
					locationsData,
				})
				.then((response) => {
					// console.log(response.data);
					this.store.setFormSubmissionData({
						status: response.data.status,
						merchantId: response.data.merchantId,
						errorMessage:
							response.data.message != undefined ? response.data.message : null,
					});
				});
		},
		async nextStep() {
			this.proceedBtnLoading = true;

			await this.submitForm().then(() => {
				this.proceedBtnLoading = false;

				this.$emit("formSubmitted");
			});
		},
		prevStep() {
			this.$emit("prevStep");
		},
		async generateRecaptchaToken() {
			let recaptchaObject = this.store.recaptchaObject;
			const gtoken = await recaptchaObject.execute("pllentyForm");

			return gtoken;
		},
		maskedCardNumber() {
			let cardNumber = this.store.S3FormData.cardNumber;

			if (cardNumber) {
				return `${"*".repeat(cardNumber.length - 4)}${cardNumber.substr(
					cardNumber.length - 4
				)}`;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.titleFont {
	font-size: 1.9rem;
}

.column-line-spacing {
	line-height: 1.4rem;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
